/**
 * Done. / ChiroCPD — EmptyState Primitive
 *
 * Used in ExportField when a field has no content.
 * CopyButton is hidden when a field is empty.
 * Uses text-secondary on surface-muted (not text-muted — contrast fix per design spec).
 */

import { cx } from '@/lib/utils';

interface EmptyStateProps {
  fieldName: string;
  guidance: string;
  actionHref?: string;
  actionLabel?: string;
  className?: string;
}

export function EmptyState({
  fieldName,
  guidance,
  actionHref,
  actionLabel,
  className,
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      className={cx(
        'rounded-[var(--radius-md)] bg-[var(--surface-muted)] px-4 py-3',
        'text-[var(--text-secondary)]',
        className,
      )}
      aria-label={`${fieldName} — no content yet`}
    >
      <p className="text-sm">{guidance}</p>
      {actionHref && (
        <a
          href={actionHref}
          className="mt-2 inline-block text-sm font-medium text-[var(--color-done-600)] hover:underline"
        >
          {actionLabel ?? 'Log an activity →'}
        </a>
      )}
    </div>
  );
}
